import StarIcon from '@material-design-icons/svg/filled/star.svg?react';

import { cn } from '../../../lib/utils';

interface RatingStarsProps {
  rating: number | null | undefined;
  className?: string;
}

export function RatingStars({ rating, className }: RatingStarsProps) {
  const value = rating ?? 0;
  return (
    <span
      className={cn('flex items-center gap-0.5', className)}
      aria-label={rating ? `${rating} out of 5 stars` : 'No rating'}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <StarIcon
          key={star}
          className={cn(
            'size-3.5 fill-current',
            star <= value ? 'text-amber-400' : 'text-neutral-700',
          )}
        />
      ))}
    </span>
  );
}
